import { render } from "./operationsDashboard.vue?vue&type=template&id=a5ddb754&scoped=true"
import script from "./operationsDashboard.vue?vue&type=script&lang=js"
export * from "./operationsDashboard.vue?vue&type=script&lang=js"

import "./operationsDashboard.vue?vue&type=style&index=0&id=a5ddb754&media=screen&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ddb754"]])

export default __exports__